const product_groups = {
	add_button: "Produktgruppe hinzufügen",
	add_dialog: {
		description: "Fügen Sie eine neue Produktgruppe hinzu.",
		form: {
			description: "Beschreibung",
			hostfact_number: "Hostfact Produktnummer (optional)",
			hostfact_number_helper:
				"Nur ausfüllen, wenn diese Gruppe ein zusammengesetztes Produkt simuliert.",
			hostfact_number_not_correct:
				'Die HostFact-Produktnummer entspricht nicht den Anforderungen ("P" gefolgt von 3 - 6 Zahlen).',
			name: "Name",
		},
		locked_group:
			"Diese Gruppe wird für Hintergrundprozesse verwendet und kann nicht geändert werden.",
		title: "Produktgruppe hinzufügen",
	},
	add_product_dialog: {
		description: "Fügen Sie ein Produkt zur ausgewählten Produktgruppe hinzu.",
		form: {
			has_own_invoice_line: "Auf separater Rechnungslinie platzieren",
			placeholder: "Produkte auswählen",
			product_name: "Produktname",
		},
		title: "Produkt hinzufügen",
	},
	delete_dialog: {
		description: "Möchten Sie die Produktgruppe <strong>{{name}}</strong> löschen?",
		group_not_empty: {
			description:
				"Es sind immer noch Produkte mit dieser Produktgruppe verknüpft. Trennen Sie sie, bevor Sie die Produktgruppe löschen.",
			title: "Gruppe ist nicht leer.",
		},
		title: "Produktgruppe löschen",
	},
	disconnect_product: {
		description: "Möchten Sie das Produkt <strong>{{name}}</strong> trennen?",
		success_alert: "Die Trennung des Produkts war erfolgreich!",
		title: "Produkt trennen",
		unknown_alert:
			"Die Trennung des Produkts ist fehlgeschlagen! Bitte versuchen Sie es später erneut.",
	},
	duplicate_dialog: {
		description:
			"Fügen Sie eine neue Produktgruppe mit den Werten der ausgewählten Produktgruppe hinzu.",
		title: "Produktgruppe hinzufügen",
	},
	edit_dialog: {
		description: "Bearbeiten Sie die ausgewählte Produktgruppe.",
		title: "Produktgruppe bearbeiten",
	},
	single_title: "Produktgruppe",
	status: {
		add_product: {
			success:
				"Das Produkt <strong>{{product_name}}</strong> wurde erfolgreich zur Produktgruppe hinzugefügt!",
			unknown:
				"Das Produkt <strong>{{product_name}}</strong> kann im Moment nicht zur Produktgruppe hinzugefügt werden. Bitte versuchen Sie es später erneut.",
		},
		create: {
			success: "Die Produktgruppe wurde hinzugefügt!",
			unknown:
				"Die Produktgruppe kann im Moment nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.",
		},
		delete: {
			not_empty:
				"Die Produktgruppe kann nicht gelöscht werden, da immer noch Produkte mit ihr verknüpft sind.",
			success: "Die Produktgruppe wurde gelöscht!",
			unknown:
				"Die Produktgruppe kann im Moment nicht gelöscht werden. Bitte versuchen Sie es später erneut.",
		},
		disconnect_product: {
			success: "Das Produkt wurde erfolgreich getrennt!",
			unknown:
				"Das Produkt kann im Moment nicht getrennt werden. Bitte versuchen Sie es später erneut.",
		},
		edit: {
			success: "Die Produktgruppe wurde erfolgreich bearbeitet!",
			unknown:
				"Die ausgewählte Produktgruppe kann im Moment nicht bearbeitet werden. Bitte versuchen Sie es später erneut.",
		},
	},
	table: {
		description: "Beschreibung",
		details: "Details",
		name: "Name",
		number: "Gruppennummer",
		products: "Produkte",
	},
	title: "Produktgruppen",
};

export default product_groups;
